/**
 * Validate the name has at least first name and last name
 * @param {string} name
 */
export const validateName = (name) =>
    !!name && typeof name === 'string' && name.length > 2 && name.length <= 100 && /\s/.test(name.trim());

export const validateBirthdate = (birthdate) => {
    return (
        !!birthdate && typeof birthdate === 'string' && birthdate.length === 10 /*&&
        /(0[1-9]|[12][\d]|3[01])-(0[1-9]|1[0-2])-(19[2-9][\d]|20[0-2][\d])/.test(birthdate.trim())*/
    );
};
